import { render } from "./FindPwd.vue?vue&type=template&id=f6b8453c&scoped=true"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"

import "./FindPwd.vue?vue&type=style&index=0&id=f6b8453c&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b8453c"]])

export default __exports__